import CommonConnectedResults from "../index";
import PromoTile from "./PromoTile";

const ConnectedResults = props => (
  <CommonConnectedResults {...props} PromoTile={PromoTile} />
);

export default ConnectedResults;
